module.exports = __webpack_public_path__ + "static/img/walter-payton-moy.51ffda7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/walter-payton-moy.png
// module id = rZQz
// module chunks = 1